import React from 'react';
import { PageTitleAnnouncer, usePageTitleAnnouncer } from './PageTitleAnnouncer';
import PageTitle from './PageTitle';
import { DocumentTitleProvider, useSetDocumentTitle } from './DocumentTitleProvider';
function PageTitleManager(_ref) {
  var pathname = _ref.pathname,
    baseTitle = _ref.baseTitle,
    _ref$syncDocumentTitl = _ref.syncDocumentTitle,
    syncDocumentTitle = _ref$syncDocumentTitl === void 0 ? false : _ref$syncDocumentTitl,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(DocumentTitleProvider, {
    baseTitle: baseTitle,
    isDisabled: !syncDocumentTitle
  }, /*#__PURE__*/React.createElement(PageTitleAnnouncer, {
    pathname: pathname
  }, children));
}
export { PageTitleManager, PageTitleAnnouncer, usePageTitleAnnouncer, DocumentTitleProvider, useSetDocumentTitle };
export default PageTitle;